<template>
  <div class="">
    <div class="row mb-3">
      <div class="col col-sm-4 pr-0">
        <input type="text" class="form-control" name="lhs" v-model="data.lhs" placeholder="LHS">
      </div>
      <div class="col col-sm-4 p-0">
        <select name="operator" v-model="data.operator" class="form-control">
          <option v-for="(operator,index) in operators" :value="operator.toLowerCase()" :key="index">{{operator}}</option>
        </select>
      </div>
      <div class="col col-sm-4 pl-0">
        <input type="text" class="form-control" name="rhs" v-model="data.rhs" placeholder="RHS">
      </div>
    </div>
    <h5>Tasks to execute if comparison not success.</h5>
    <Task :tasks="data.else_tasks" :actions="actions"></Task>
  </div>
</template>


<script type="text/javascript">

  export default {
    name: 'Compare',
    components: {
      Task: () => import("@/components/Task.vue")
    },
    props: {
      data: Object,
      actions: Object
    },
    data: function() {
      return {
        operators: ["Equal to", "Not equal to","Greater than", "Smaller than", "Greater than or Equal to", "Smaller than or Equal to"]
      }
    }
  }
</script>
